import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const EVENTS = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
const IDLE_THRESHOLD_MS = 2 * 60 * 1000; // 2 minutos sin tocar mouse/teclado = Inactivo

export const getModuleName = (pathname: string): string => {
  if (pathname.includes('/conversations')) return 'CONVERSACIONES';
  if (pathname.includes('/pipeline')) return 'PIPELINE';
  if (pathname.includes('/contacts')) return 'CONTACTOS';
  if (pathname.includes('/calendar')) return 'CALENDARIO';
  if (pathname.includes('/real-estate')) return 'INVENTARIO';
  if (pathname.includes('/dashboard')) return 'DASHBOARD';
  if (pathname.includes('/team')) return 'EQUIPO';
  if (pathname.includes('/settings')) return 'CONFIGURACION';
  if (pathname.includes('/meta-ads') || pathname.includes('/campaigns')) return 'MARKETING';
  return 'GENERAL';
};

const useActivityTracker = () => {
  const { user } = useAuth();
  const location = useLocation();
  const lastActiveRef = useRef<number>(Date.now());
  const pathRef = useRef<string>(location.pathname);

  useEffect(() => {
    pathRef.current = location.pathname;
  }, [location.pathname]);

  useEffect(() => {
    if (!user) return;

    const onUserInteraction = () => {
      lastActiveRef.current = Date.now();
    };

    EVENTS.forEach(ev => window.addEventListener(ev, onUserInteraction, { passive: true }));

    // Enviar pulso cada 60 segundos
    const interval = setInterval(() => {
      const isVisible = document.visibilityState === 'visible';
      const hasInteractedRecently = (Date.now() - lastActiveRef.current) < IDLE_THRESHOLD_MS;
      const isActuallyActive = isVisible && hasInteractedRecently;

      const currentPath = pathRef.current;
      const currentModule = getModuleName(currentPath);

      api.post('/activity/heartbeat', {
        module: currentModule,
        path: currentPath,
        activeSeconds: isActuallyActive ? 60 : 0,
        isIdle: !isActuallyActive
      }).catch(() => {});
    }, 60 * 1000);

    return () => {
      clearInterval(interval);
      EVENTS.forEach(ev => window.removeEventListener(ev, onUserInteraction));
    };
  }, [user]);
};

export default useActivityTracker;
